const HIGH_PRIORITY_MODALITIES = Object.freeze([
  'KO',
  'PR',
]);

export default function isHighPriorityModality(Modality) {
  return HIGH_PRIORITY_MODALITIES.includes(Modality);
}
